import { render } from "./VersionsView.vue?vue&type=template&id=65266fed"
import script from "./VersionsView.vue?vue&type=script&lang=js"
export * from "./VersionsView.vue?vue&type=script&lang=js"

import "./VersionsView.vue?vue&type=style&index=0&id=65266fed&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__